import React, { useCallback, useContext } from 'react';
import { useBookingContext } from '../../Context';
import { BookerStateContext } from '../../hooks/useRuntimeCalBookingState';
import { getSeatReferenceUid, isSeatReferenceBooking } from '../../utils';
import BookingConfirmContainer from './BookingConfirmContainer';

const BookingConfirmWrapper = () => {
    const bookerContext = useBookingContext();
    const [bookingState, bookingActions] = useContext(BookerStateContext);

    const { isBookingDryRun } = bookerContext;
    const { confirmationData } = bookingState;

    const { clearConfirmationData, setRescheduleUid, setCancelBookingId } =
        bookingActions;

    const rescheduleBooking = useCallback(() => {
        if (!confirmationData?.uid) {
            return;
        }

        const rescheduleUid = isSeatReferenceBooking(confirmationData)
            ? getSeatReferenceUid(confirmationData)
            : confirmationData.uid;
        setRescheduleUid(rescheduleUid);
        clearConfirmationData();
    }, [confirmationData, setRescheduleUid, clearConfirmationData]);

    const cancelBooking = useCallback(() => {
        if (!confirmationData?.uid) {
            return;
        }
        const cancelUid = isSeatReferenceBooking(confirmationData)
            ? getSeatReferenceUid(confirmationData)
            : confirmationData.uid;
        setCancelBookingId(cancelUid);
        clearConfirmationData();
    }, [confirmationData, setCancelBookingId, clearConfirmationData]);

    const showConfirmation = !isBookingDryRun && confirmationData;

    if (!showConfirmation) {
        return null;
    }

    return (
        <BookingConfirmContainer
            confirmationData={confirmationData}
            closeConfirmation={clearConfirmationData}
            rescheduleBooking={rescheduleBooking}
            cancelBooking={cancelBooking}
        />
    );
};

export default BookingConfirmWrapper;
